module.exports = __webpack_public_path__ + "img/eval_blockdaigram_ECJA.3b759fa9.png";